var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"firmware-table-container"},[_c('firmware-versions-table',{staticClass:"firmware-table",attrs:{"height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }